/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react'
import { message, Radio } from 'antd'
import classNames from 'classnames'
import request from '../../utils/request'
import TagList from './tagSelection'
import Input from '../../baseComponent/input'
import Cascade from '../../baseComponent/cascade'
import { StyleSelect, SelectDay, SelectMonth, SelectYear, MnInputNum, MultipleSelect, MultipleCascader, MnTextInput } from './styleSelect'

const ATTR_TYPE = { 1: '纯文本', 2: '文本标签', 3: '数字', 4: '超链接', 5: '布尔值', 6: '单项选择', 7: '多项选择', 8: '日期', 9: '成员选择' }
const BOOLEAN_DATA = { IS_TRUE: 1, IS_FALSE: 0 }

const cascadeConvert = (result) => {
  const options = []
  result?.forEach((item) => {
    let node = null
    node = { label: item.value, value: item.value, parent: item.parent, level: 1 }
    if (item.childItems?.length) {
      item.childItems = item.childItems.map(m => ({ ...m, parent: node }))
      node.children = cascadeConvert(item.childItems)
    }
    options.push(node)
  })
  return options
}

export const AttrFactory = (props) => {
  const { visible, industryAtrr, value, onChange, type, className } = props
  const [userOptions, setUserOptions] = useState([])
  useEffect(() => {
    fetchUsers()
  }, [visible])
  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/user-selector')
      setUserOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }
  const convert = (result) => {
    return result.map(m => ({ label: m.userName, value: m.userId }))
  }
  const events = {
    onChange(propertyId, attrVal, propertyType, propertyName) {
      onChange && onChange(propertyId, attrVal, propertyType, propertyName)
    },
    onNumChange(propertyId, attrVal, propertyType, propertyName) {
      if (!/^\d+(.\d{1,2})?$/.test(Number(attrVal))) {
        // message.warning('请输入整数或小数（小数点后最多两位）')
        return
      }
      if (Math.ceil(Number(attrVal)) > 10000000) {
        return message.warning('最多支持输入9999999.99')
      }
      onChange && onChange(propertyId, attrVal, propertyType, propertyName)
    },
    onTagsChange(propertyId, attrVal, propertyType, propertyName) {
      onChange && onChange(propertyId, attrVal, propertyType, propertyName)
    }
  }
  return <div className={classNames('custom-attr-container', className)}>
    {industryAtrr?.length > 0 ? industryAtrr.map((m) => {
      if (m.isVisible) {
        return <div className="attr-item">
          <div className="label">{m.propertyName}</div>
          <div className="custom-com">{renderAttr(m, value, events, userOptions, type)}</div>
        </div>
      }
    }) : null }
  </div>
}

const renderAttr = (attr, defaultValue, events, userOptions, type) => {
  if (ATTR_TYPE[attr.propertyType] == '纯文本') {
    return <MnTextInput localType={type} localKey={attr.propertyId} value={findValueById(attr.propertyId, defaultValue)?.values[0] || ''} onChange={value => events.onTagsChange(attr.propertyId, value, attr.propertyType, attr.propertyName)} />
  }
  if (ATTR_TYPE[attr.propertyType] == '文本标签') {
    return <TagList
      localType={type}
      localKey={attr.propertyId}
      className="style-lable-tag"
      value={findValueById(attr.propertyId, defaultValue)?.values || []}
      onChange={value => events.onTagsChange(attr.propertyId, value, attr.propertyType, attr.propertyName)}
      suffix={20}
      style={{ width: '100%', marginBottom: 0 }}
    />
  }
  if (ATTR_TYPE[attr.propertyType] == '数字') {
    return <MnInputNum
      maxNum={99999999}
      value={findValueById(attr.propertyId, defaultValue)?.values}
      onChange={value => events.onNumChange(attr.propertyId, value, attr.propertyType, attr.propertyName)}
    />
  }
  if (ATTR_TYPE[attr.propertyType] == '超链接') {
    return <Input
      placeholder="请输入超链接"
      wrapStyle={{ width: '100%' }}
      withBorder
      value={findValueById(attr.propertyId, defaultValue)?.values[0] || ''}
      onChange={e => events.onTagsChange(attr.propertyId, e.target.value, attr.propertyType, attr.propertyName)}
      maxLength={200}
      // wrapStyle={{ flex: 1 }}
    />
  }
  if (ATTR_TYPE[attr.propertyType] == '布尔值') {
    return attr.booleanStruct.showValue == 1
      ? <Radio.Group
          value={findValueById(attr.propertyId, defaultValue)?.values[0] - 0 || 0}
          onChange={e => events.onChange(attr.propertyId, e.target.value, attr.propertyType, attr.propertyName)}
      >
        <Radio value={BOOLEAN_DATA.IS_TRUE}>是</Radio>
        <Radio value={BOOLEAN_DATA.IS_FALSE}>否</Radio>
      </Radio.Group>
      : <Radio.Group
          value={findValueById(attr.propertyId, defaultValue)?.values[0] - 0 || 0}
          onChange={e => events.onChange(attr.propertyId, e.target.value, attr.propertyType, attr.propertyName)}
      >
        <Radio value={BOOLEAN_DATA.IS_TRUE}>有</Radio>
        <Radio value={BOOLEAN_DATA.IS_FALSE}>无</Radio>
      </Radio.Group>
  }
  if (ATTR_TYPE[attr.propertyType] == '单项选择') {
    if (isChildren(attr.singleStruct.rootItems)) {
      return <Cascade
        trigger="click"
        allowClear={false}
        placeholder="点击选择"
        value={findValueById(attr.propertyId, defaultValue)?.values?.length > 0 ? findValueById(attr.propertyId, defaultValue)?.values : []}
        options={cascadeConvert(attr.singleStruct.rootItems)}
        onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)}
      />
    }
    return <StyleSelect
      placeholder="点击选择"
      value={findValueById(attr.propertyId, defaultValue)?.values?.length > 0 ? findValueById(attr.propertyId, defaultValue)?.values : ''}
      options={dealData(attr.singleStruct.rootItems)}
      onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)}
    />
  }
  if (ATTR_TYPE[attr.propertyType] == '多项选择') {
    if (isChildren(attr.multiStruct.rootItems)) {
      return <MultipleCascader placeholder="点击选择" value={findValueById(attr.propertyId, defaultValue)?.values} options={dealData(attr.multiStruct.rootItems)} onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)} />
    }
    return <MultipleSelect placeholder="点击选择" value={findValueById(attr.propertyId, defaultValue)?.values} asyncoptions={dealData(attr.multiStruct.rootItems)} onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)} />
  }
  if (ATTR_TYPE[attr.propertyType] == '日期') {
    if (attr.dateStruct.viewType == 1) {
      return <SelectYear value={findValueById(attr.propertyId, defaultValue)?.values?.length > 0 ? findValueById(attr.propertyId, defaultValue)?.values : ''} onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)} />
    }
    if (attr.dateStruct.viewType == 2) {
      return <SelectMonth value={findValueById(attr.propertyId, defaultValue)?.values?.length > 0 ? findValueById(attr.propertyId, defaultValue)?.values : ''} onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)} />
    }
    if (attr.dateStruct.viewType == 3) {
      return <SelectDay value={findValueById(attr.propertyId, defaultValue)?.values?.length > 0 ? findValueById(attr.propertyId, defaultValue)?.values : ''} onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)} />
    }
  }
  if (ATTR_TYPE[attr.propertyType] == '成员选择') {
    if (attr.memberStruct.isMulti) {
      return <MultipleSelect placeholder="点击选择" value={convertMember(findValueById(attr.propertyId, defaultValue)?.values)} asyncoptions={userOptions} onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)} />
    }
    return <StyleSelect placeholder="点击选择" value={convertMember(findValueById(attr.propertyId, defaultValue)?.values)} options={userOptions} onChange={value => events.onChange(attr.propertyId, value, attr.propertyType, attr.propertyName)} />
  }
}

// 判断他的一级children有没有数据
const isChildren = (data) => {
  return data.some(item => item.childItems.length > 0)
}

// 处理数据
const dealData = (data) => {
  for (let i = 0; i < data.length; i++) {
    if (!data[i].label) {
      data[i].label = data[i].value
    }
    if (data[i].childItems.length > 0 && !data[i].children) {
      data[i].children = data[i].childItems
    }
    if (data[i].childItems) {
      dealData(data[i].childItems)
    }
  }
  return data
}

// 对数组中的字符串进行隐式转换
const convertMember = (data) => {
  if (data?.length > 0) {
    return data?.map(item => item - 0)
  }
  return []
}

// 根据id找到对应的属性值
const findValueById = (id, attr) => {
  if (attr?.length > 0) {
    return attr.find(m => m.propertyId == id)
  }
  return []
}
